import React from 'react'
import Dialog from '@material-ui/core/Dialog'
import DialogActions from '@material-ui/core/DialogActions'
import DialogContent from '@material-ui/core/DialogContent'
import DialogContentText from '@material-ui/core/DialogContentText'
import DialogTitle from '@material-ui/core/DialogTitle'
import { Button } from '@material-ui/core'

const Confirmation = props => {
  const {
    confirmationMsg,
    closeModalConfirmationMsg,
    confirmationMsgText,
    confirmationTitleText
  } = props

  return (
    <Dialog
      open={confirmationMsg}
      onClose={closeModalConfirmationMsg}
      aria-labelledby='confirmation-dialog'
      disableBackdropClick
    >
      <DialogTitle id='form-dialog-title'>{confirmationTitleText}</DialogTitle>
      <DialogContent>
        <DialogContentText>{confirmationMsgText}</DialogContentText>
      </DialogContent>
      <DialogActions>
        <Button onClick={closeModalConfirmationMsg} color='primary'>
          Ok
        </Button>
      </DialogActions>
    </Dialog>
  )
}

Confirmation.propTypes = {}

export default Confirmation
